import { useRef } from 'react';
import { useAppSelector } from '@hooks/reduxHooks';
import { Edge, Node } from '@xyflow/react';

export function useTrackFlowChanges() {
  const nodes = useAppSelector(state => state.aiAgentReducer.nodes);
  const edges = useAppSelector(state => state.aiAgentReducer.edges);
  const prevNodesRef = useRef<Node[]>(nodes);
  const prevEdgesRef = useRef<Edge[]>(edges);

  const resetChanges = () => {
    prevNodesRef.current = nodes;
    prevEdgesRef.current = edges;
  };

  return { resetChanges };
}
